import { createRef } from 'react';
import { useRecoilValue } from 'recoil';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import Button from '@mui/material/Button';
import SandhillsReCAPTCHA from '@Components/Shared/SandhillsReCAPTCHA';

const PaymentAuthorizationSubmitButtons = (props) => {

    const recaptchaRef = createRef();
    const routes = useRecoilValue(atoms.routes);
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const onSubmit = (e) => {
        e.preventDefault();

        if (props.Captcha) {
            let captchaToken = recaptchaRef.current?.getValue();
            if (captchaToken !== '') {
                props.setLoading?.(() => true);
                props.setError?.(() => '');
                recaptchaRef.current.reset();
                sandhillsRequest({
                    url: routes.ValidateReCaptchaToken,
                    data: { reCaptchaToken: captchaToken },
                    method: 'post',
                    errorHandling: {
                        showDetails: true,
                        useConsole: true,
                        useAlert: false
                    }
                }).then((success) => {
                    props.setLoading?.(() => false);
                    if (success === true) {
                        props.submitForm();
                    }
                    else {
                        props.setError?.(() => translator.translate('sandhills.pleasesubmitrecaptchabeforesubmittingcard'));
                    }
                }).catch((error) => {
                    props.setLoading?.(() => false);
                    props.setError?.(() => translator.translate('sandhills.ErrorOccurredValidatingReCaptcha'));
                });
            }
            else {
                props.setError?.(() => translator.translate('sandhills.pleasesubmitrecaptchabeforesubmittingcard'));
            }
        }
        else {
            props.submitForm();
        }
    };

    return (
        <div>
            {(props.Captcha && !props.loading) &&
                <div className='captcha-checkbox'>
                    <SandhillsReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={props.Captcha.Key}
                        size={'normal'}
                    />
                </div>}
            <Button variant='contained' onClick={onSubmit} disabled={props.loading} className={'template-branded-button ' + (currentSite?.Site?.IsAuctionSite ? 'ts-button' : '')}>
                {translator.translate(props.savedPayment || !props.savePaymentMethods ? 'sandhills.tradepubwebsite.mvc.submit' : 'sandhills.saveandsubmit')}
            </Button>
            <div id='credit-card-submit' className='hide'></div>
            {(props.showLogo && props.LogoUrl && !props.savedPayment) &&
                <div className={'payment-auth-logo'}>
                    <img src={props.LogoUrl} alt="" />
                </div>}
        </div>
    );
}

export default PaymentAuthorizationSubmitButtons;